import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHotkeys } from 'react-hotkeys-hook';

export default function GlobalPage() {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEntries = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch('/.netlify/functions/listTopics?limit=2000');
        if (!res.ok) throw new Error('Failed to fetch');
        const data = await res.json();
        const uniq = new Map();
        (data.entries || []).forEach((e) => {
          const key = String((e.subject || '').trim()).toLowerCase();
          if (!key) return;
          if (!uniq.has(key)) uniq.set(key, e.subject);
        });
        setSubjects(Array.from(uniq.values()).sort((a, b) => a.localeCompare(b)));
      } catch (e) {
        setError('Failed to load');
      } finally {
        setLoading(false);
      }
    };
    fetchEntries();
  }, []);

  return (
    <div className="play-page">
      <span className="subject-label">Global</span>
      <div className="container center">
        {loading && <div className="centertext">Loading...</div>}
        {error && <div className="text-danger">{error}</div>}
        {!loading && !error && (
          <div className="options">
            {subjects.map((s, idx) => (
              <button
                key={s}
                className={`option center ${selectedIndex === idx ? 'selected-option' : ''}`}
                onClick={() => navigate(`/play/${encodeURIComponent(s)}`)}
              >
                {s}
              </button>
            ))}
          </div>
        )}
        <Hotkeys selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} subjects={subjects} onEnter={() => {
          const s = subjects[selectedIndex];
          if (s) navigate(`/play/${encodeURIComponent(s)}`);
        }} />
      </div>
    </div>
  );
}

function Hotkeys({ selectedIndex, setSelectedIndex, subjects, onEnter }) {
  useHotkeys('ArrowUp', () => {
    if (!subjects.length) return;
    setSelectedIndex((prev) => (prev - 1 + subjects.length) % subjects.length);
  }, [subjects, setSelectedIndex]);

  useHotkeys('ArrowDown', () => {
    if (!subjects.length) return;
    setSelectedIndex((prev) => (prev + 1) % subjects.length);
  }, [subjects, setSelectedIndex]);

  useHotkeys('Enter', (event) => {
    event.preventDefault();
    onEnter();
  }, [onEnter, selectedIndex, subjects]);

  return null;
}


